<div class="uig-breadcrumb">
  <nav>
    @for (crumb of crumbs$ | async; track crumb) {
      <span>
        <a [routerLink]="crumb.link" [innerHTML]="crumb.label"></a>
      </span>
    }
  </nav>
  <h3>{{ title$ | async }}</h3>
</div>
